import { I18n } from "@assets/strings";
import { Media } from "@domain/media/media";
import { UploadError } from "@domain/media/mediaService";
import { createToast } from "@ui/toasts/utils";

export function dataURLToFile(dataUrl: string, fileName: string): File {
	// parse dataURl;
	const arr = dataUrl.split(",");

	// get the mimeType
	const mime = <RegExpMatchArray>arr[0].match(/:(.*?);/);

	// decode blob
	const blobString = window.atob(arr[1]);
	const N = blobString.length;
	const u8arr = new Uint8Array(N);
	for (let n = N - 1; n >= 0; n--) {
		u8arr[n] = blobString.charCodeAt(n);
	}

	return new File([u8arr], fileName, { type: mime[1] });
}

export const combineAvatarWithFilter = async (avatar: Media, filter: Media): Promise<File> => {
	const profileImage = new Image();
	profileImage.crossOrigin = "anonymous";
	await new Promise((r) => {
		profileImage.onload = r;
		profileImage.src = avatar.url.concat("?", "bypassChrome=true");
	});

	const filterImage = new Image();
	filterImage.crossOrigin = "anonymous";
	await new Promise((r) => {
		filterImage.onload = r;
		filterImage.src = filter.url.concat("?", "bypassChrome=true");
	});

	const canvas = document.createElement("canvas");
	canvas.width = 300;
	canvas.height = 300;
	const context = canvas.getContext("2d") as CanvasRenderingContext2D;
	context.beginPath();
	context.globalAlpha = 1.0;
	context.arc(150, 150, 150, 0, 2 * Math.PI);
	context.clip();
	context.drawImage(profileImage, 0, 0, 300, 300);
	context.globalAlpha = 1.0;
	context.drawImage(filterImage, -60, -60, 420, 420);

	return dataURLToFile(canvas.toDataURL("image/png"), avatar.mimeType.split("/")[1] ?? "png");
};

export const handleUploadFileError = (e: Error, onError?: () => void): void => {
	if (e.message === UploadError.ALREADY_PENDING) {
		createToast(I18n.t("error"), I18n.t("upload.error.pending"), "error");
	}
	if (e.message === UploadError.UNKNOWN) {
		createToast(I18n.t("error"), I18n.t("upload.erorr.unknown"), "error");
	}
	if (e.message === UploadError.CANCELED) {
		createToast(I18n.t("info"), I18n.t("upload.canceled"));
	}
	onError?.();
};
